import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import { useWidgetHelp } from 'src/hook';
import { ETransactionStatus } from 'src/type';
import { IPaymentTransactionItem } from 'src/store/slice/payment/interface';
import { getTransactionStatus } from 'src/utils/getTransactionStatus';

import { selectPaymentTransactions, selectPayment } from 'src/store/slice/payment/state';

import Transaction from 'src/components/transactions/transaction';

import './transactions.scss';

const Transactions: React.FC = (): JSX.Element => {
  const { t } = useTranslation();

  const { isOpenDepositInvoice, isDefaultInvoice, isSetedDefaultInvoiceCurrency, isRequesSuccess } = useWidgetHelp();

  const payment = useSelector(selectPayment);
  const paymentTransactions = useSelector(selectPaymentTransactions);

  const { target_currency_amount_required, target_currency_amount_paid } = payment || {};

  const isShowDefaultTransactionProgress = isDefaultInvoice
    ? (target_currency_amount_paid || 0) < (target_currency_amount_required || 0)
    : isOpenDepositInvoice;

  const transactions = paymentTransactions.filter(
    (transaction: IPaymentTransactionItem) => transaction?.status !== ETransactionStatus.Completed
  );

  const completedTransaction = paymentTransactions.filter(
    (transaction: IPaymentTransactionItem) => transaction?.status === ETransactionStatus.Completed
  );

  return (
    <>
      <ul className="transactions">
        {isShowDefaultTransactionProgress && (
          <Transaction
            title={t('TITLE.LISTENING_FOR_A_NEW_TRANSACTION')}
            isSetedDefaultInvoiceCurrency={isSetedDefaultInvoiceCurrency}
            isRequesSuccess={isRequesSuccess}
          />
        )}

        {isDefaultInvoice &&
          paymentTransactions.map((transaction: IPaymentTransactionItem) => (
            <Transaction
              key={transaction.crypto_transaction_id}
              title={t(
                getTransactionStatus(transaction?.confirmations, transaction.status === ETransactionStatus.Completed)
              )}
              transaction={transaction}
              payment={payment}
              isSetedDefaultInvoiceCurrency={isSetedDefaultInvoiceCurrency}
              isRequesSuccess={isRequesSuccess}
              isOpenDepositInvoice={isOpenDepositInvoice}
            />
          ))}

        {isOpenDepositInvoice &&
          transactions.map((transaction: IPaymentTransactionItem) => (
            <Transaction
              key={transaction.crypto_transaction_id}
              title={t(
                getTransactionStatus(transaction?.confirmations, transaction.status === ETransactionStatus.Completed)
              )}
              transaction={transaction}
              payment={payment}
              isSetedDefaultInvoiceCurrency={isSetedDefaultInvoiceCurrency}
              isRequesSuccess={isRequesSuccess}
              isOpenDepositInvoice={isOpenDepositInvoice}
            />
          ))}
      </ul>

      {isOpenDepositInvoice && !!completedTransaction.length && (
        <section className="previous-transactions">
          <h3 className="previous-transactions-title">{t('TITLE.PREVIOUS_TRANSACTIONS')}</h3>

          <ul className="transactions">
            {completedTransaction.map((transaction: IPaymentTransactionItem) => (
              <Transaction
                key={transaction.crypto_transaction_id}
                title={t(
                  getTransactionStatus(transaction?.confirmations, transaction.status === ETransactionStatus.Completed)
                )}
                transaction={transaction}
                payment={payment}
                isSetedDefaultInvoiceCurrency={isSetedDefaultInvoiceCurrency}
                isRequesSuccess={isRequesSuccess}
                isOpenDepositInvoice={isOpenDepositInvoice}
              />
            ))}
          </ul>
        </section>
      )}
    </>
  );
};

export default Transactions;
